import React from 'react'
// import { TypeAnimation } from 'react-type-animation';
// import HeroBg from '../assets/hero-bg.png'

const ContactLanding = () => {
  return (
    <div className='hero-bg-about'>
      <div className='container'>
        <div className='row'>
          <div className='col-12 col-md-12 text-white'>
            <h1 className='display-1 text-white fw-bolder'>About Us</h1>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactLanding
